<div class="row">
  <div class="col-md-12 text-center mb-3">
    <span class="MM24 font-weight-bold">Search Claims</span>
  </div>
</div>
<!--Search Fields-->
<div class="row row_flex" [formGroup]="searchForm">
  <div class="col-md-5">
    <mat-form-field class="example_full_width">
      <mat-label class="label_flex">Claim Id
        <span class="text-danger" *ngIf="searchClaim">*</span>
      </mat-label>
      <input type="text" aria-label="text" formControlName="ClaimId" (keyup)="updateValidity('claimId')" matInput />
      <mat-error *ngIf="
          searchForm.controls.ClaimId.touched &&
          searchForm.controls.ClaimId.hasError('required')
        ">
        Enter Claim id
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-md-2" style="padding-top: 2%; text-align: center">
    <span class="MM16">- OR -</span>
  </div>
  <div class="col-md-5">
    <mat-form-field class="example_full_width">
      <mat-label class="label_flex">Member Id
        <span class="text-danger" *ngIf="searchMember">*</span>
      </mat-label>
      <input type="text" aria-label="text" matInput (keyup)="updateValidity('memberId')" formControlName="memberId" />
      <mat-error *ngIf="
          searchForm.controls.memberId.touched &&
          searchForm.controls.memberId.hasError('required')
        ">
        Enter Member id
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div class="row row_flex">
  <div class="col-md-6">
    <button type="button" mat-raised-button class="action_btn" style="float: right" [disabled]="!searchForm.valid"
      (click)="getMemberClaimDetails()">
      Search
    </button>
  </div>
  <div class="col-md-6">
    <button mat-raised-button type="button" class="action_btn" style="background-color: #de3e4e !important; float: left"
      (click)="close()">
      Cancel
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table mat-table class="MM16 mat-elevation-z8" [dataSource]="memberData">
      <ng-container matColumnDef="claimId">
        <th mat-header-cell *matHeaderCellDef>Claim ID</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <ng-template [ngIf]="element?.type == 'Group'">
          <ng-template [ngIf]="!element?.tpaClaimId">
            {{ element?.alternateClaimId }}
          </ng-template>
          <ng-template [ngIf]="element?.tpaClaimId">
            {{ element?.tpaClaimId }}
          </ng-template>
        </ng-template>
        <ng-template [ngIf]="element?.type == 'Retail'"> 
          <ng-template [ngIf]="element?.claimId">
            {{ element?.claimId }}
          </ng-template>
        </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="claimStatus">
        <th mat-header-cell *matHeaderCellDef>Claim Status</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <ng-template [ngIf]="
          element?.claimStatus != 'MEMBER_UNENDORSED' &&
          element?.claimStatus !=
                            'PRE_AUTH_UNDER_REVIEW' &&
                            element?.claimStatus !=
                            'FINAL_BILLS_UNDER_REVIEW' &&
                            element?.claimStatus !=
                            'ENHANCEMENT_UNDER_REVIEW'  &&
                            element?.claimStatus !=
                              'READY_TO_PAY'  &&
                              element?.claimStatus !=
                                'UPLOADED_FOR_PAYMENT'">
            {{
            element?.claimStatus?.replaceAll("_", " ")
            | titlecase
            }}
          </ng-template>
          <ng-template [ngIf]="
        element?.claimStatus === 'READY_TO_PAY' || element?.claimStatus === 'UPLOADED_FOR_PAYMENT'
      ">
            Scanned File Received
          </ng-template>

          <ng-template [ngIf]="
    element?.claimStatus === 'MEMBER_UNENDORSED'
      ">
            Pre Auth Submitted
          </ng-template>

          <ng-template [ngIf]="
    element?.claimStatus === 'PRE_AUTH_UNDER_REVIEW'
      ">
            Pre Auth Submitted
          </ng-template>

          <ng-template [ngIf]="
    element?.claimStatus ===
        'FINAL_BILLS_UNDER_REVIEW'
      ">
            Final Bills Submitted
          </ng-template>

          <ng-template [ngIf]="
    element?.claimStatus ===
        'ENHANCEMENT_UNDER_REVIEW'
      ">
            Enhancement Submitted
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="admissionDate">
        <th mat-header-cell *matHeaderCellDef>Admission Date</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          {{ element.admissionDate | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dischargeDate">
        <th mat-header-cell *matHeaderCellDef>Discharge Date</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          {{ element.dischargeDate | date: "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="memberId">
        <th mat-header-cell *matHeaderCellDef>Member ID</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          {{ element.memberId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="memberName">
        <th mat-header-cell *matHeaderCellDef>Member Name</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          {{ element.memberName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="assign">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button class="mr-2" color="primary" *ngIf="element.claimStatus === 'SAVED_CLAIM'"
            (click)="openClaimInitiation(element.claimId)">Process</button>
          <ng-template [ngIf]="element.type =='Group'">
            <ng-template [ngIf]="element.claimStatus != 'SAVED_CLAIM'">
              <ng-template [ngIf]="!element.isUnRegisteredFlow">
                <button mat-raised-button *ngIf="
                element.claimStatus != 'PRE_AUTH_SUBMITTED' && element.claimStatus != 'PRE_AUTH_UNDER_REVIEW' && 
                element.claimStatus != 'PRE_AUTH_QUERY_RESPONDED' && element.claimStatus != 'MEMBER_UNENDORSED' && 
                element.claimStatus != 'FINAL_BILLS_SUBMITTED' && element.claimStatus != 'FINAL_BILLS_UNDER_REVIEW'
                && element.claimStatus != 'FINAL_BILLS_QUERY_RESPONDED' && element.claimStatus != 'ENHANCEMENT_SUBMITTED' 
                && element.claimStatus != 'ENHANCEMENT_UNDER_REVIEW' && element.claimStatus != 'ENHANCEMENT_QUERY_RESPONDED'
                && element.claimStatus != 'SCANNED_FILE_RECEIVED' && element.claimStatus != 'READY_TO_PAY'
                && element.claimStatus != 'UPLOADED_FOR_PAYMENT' && element.claimStatus != 'CLAIM_REJECTED' && element.claimStatus != 'SETTLED' 
                " class="mr-2" color="primary" (click)="openClaimDetails(element.claimId, 'assign')">Assign</button>
              </ng-template>
              <ng-template [ngIf]="element.isUnRegisteredFlow">
                <button mat-raised-button *ngIf="
                element.claimStatus != 'CLAIM_REJECTED' && element.claimStatus != 'SETTLED'
                " class="mr-2" color="primary" (click)="openClaimDetails(element.claimId, 'assign')">Assign</button>
              </ng-template>
  
              <button mat-raised-button color="accent" (click)="openClaimDetails(element.claimId, 'view')">View</button>
            </ng-template>
          </ng-template>
          <ng-template [ngIf]="element.type =='Retail'">
            <ng-template [ngIf]="element.claimStatus != 'SAVED_CLAIM'">
            
                <button mat-raised-button *ngIf="
                element.claimStatus != 'PRE_AUTH_SUBMITTED' && element.claimStatus != 'PRE_AUTH_UNDER_REVIEW' && 
                element.claimStatus != 'PRE_AUTH_QUERY_RESPONDED' && element.claimStatus != 'MEMBER_UNENDORSED' && 
                element.claimStatus != 'FINAL_BILLS_SUBMITTED' && element.claimStatus != 'FINAL_BILLS_UNDER_REVIEW'
                && element.claimStatus != 'FINAL_BILLS_QUERY_RESPONDED' && element.claimStatus != 'ENHANCEMENT_SUBMITTED' 
                && element.claimStatus != 'ENHANCEMENT_UNDER_REVIEW' && element.claimStatus != 'ENHANCEMENT_QUERY_RESPONDED'
                && element.claimStatus != 'SCANNED_FILE_RECEIVED' && element.claimStatus != 'READY_TO_PAY'
                && element.claimStatus != 'UPLOADED_FOR_PAYMENT' && element.claimStatus != 'CLAIM_REJECTED' && element.claimStatus != 'SETTLED' 
                " class="mr-2" color="primary" (click)="openClaimDetails(element.claimId, 'assign')">Assign</button>
            
              <button *ngIf="hasNoTCA(element)" mat-raised-button color="accent" (click)="openRetailClaimDetails(element.claimId, 'view')">View</button>
              <button *ngIf="hasCA(element)" mat-raised-button color="accent" (click)="openClaimDetails(element.claimId, 'view')">View</button>
            </ng-template>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <table>
      <tr *ngIf="!memberData.data.length && loaderHide">
        <td class="cell" [attr.colspan]="displayedColumns.length">
          No Records Found!
        </td>
      </tr>
      <tr *ngIf="!memberData.data.length && !loaderHide">
        <td class="cell" [attr.colspan]="displayedColumns.length">
          Loading, please wait...
        </td>
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 20, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>